export default __webpack_public_path__ + "static/media/error-icon.30ff2119.svg";